
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5078 7C11.5078 7.55229 11.0603 8 10.5082 8C9.9562 8 9.50868 7.55229 9.50868 7V6C9.50868 3.79086 11.2988 2 13.5069 2H18.0019C20.21 2 22.0001 3.79086 22.0001 6V18C22.0001 20.2091 20.21 22 18.0019 22H13.5C11.2918 22 9.50173 20.2091 9.50173 18V17C9.50173 16.4477 9.94926 16 10.5013 16C11.0533 16 11.5009 16.4477 11.5009 17V18C11.5009 19.1046 12.3959 20 13.5 20H18.0019C19.1059 20 20.001 19.1046 20.001 18V6C20.001 4.89543 19.1059 4 18.0019 4H13.5069C12.4028 4 11.5078 4.89543 11.5078 6V7Z","fill":"#10001F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.70711 8.29289C7.09763 8.68342 7.09763 9.31658 6.70711 9.70711L5.41421 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H5.41421L6.70711 14.2929C7.09763 14.6834 7.09763 15.3166 6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071L2.29289 12.7071C1.90237 12.3166 1.90237 11.6834 2.29289 11.2929L5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289Z","fill":"#10001F"}})])
          )
        }
      }
    